import httpStore from "@/api/httpStore.js";

export function getLocations() {
  return httpStore
    .get("location_departments_priority/index")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
// data should contain 'country_code', 'postal_code', 'departamento_id'
export function createLocationDepartment(data) {
  return httpStore
    .post("location_departments_priority/index", data)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

// Update existing location department
export function updateLocationDepartment(id, data) {
  return httpStore
    .put(`location_departments_priority/index/${id}`, data)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

// Delete location department
export function deleteLocationDepartment(id) {
  return httpStore
    .delete(`location_departments_priority/index/${id}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
